(() => {
  const SECTION_SELECTOR = '.oddit-section-blog-grid';
  const sectionState = new Map();

  function initSection(section) {
    const track = section.querySelector('.oddit-section-blog-grid__grid');
    const prevBtn = section.querySelector('.oddit-section-blog-grid__slider-btn--prev');
    const nextBtn = section.querySelector('.oddit-section-blog-grid__slider-btn--next');

    if (!track || !prevBtn || !nextBtn) return;

    const state = {};
    sectionState.set(section.id || section, state);

    function getSlideWidth() {
      const firstCard = track.querySelector('.oddit-section-blog-grid__card');
      if (!firstCard) return 0;
      const style = getComputedStyle(track);
      const gap = parseFloat(style.gap) || 16;
      return firstCard.offsetWidth + gap;
    }

    function updateArrowStates() {
      const maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = track.scrollLeft <= 1;
      nextBtn.disabled = track.scrollLeft >= maxScroll - 1;
    }

    function scrollPrev() {
      const slideWidth = getSlideWidth();
      track.scrollBy({ left: -slideWidth, behavior: 'smooth' });
    }

    function scrollNext() {
      const slideWidth = getSlideWidth();
      track.scrollBy({ left: slideWidth, behavior: 'smooth' });
    }

    prevBtn.addEventListener('click', scrollPrev);
    nextBtn.addEventListener('click', scrollNext);
    track.addEventListener('scroll', updateArrowStates, { passive: true });

    // The section CSS loads async (media="print" onload), so the very first
    // updateArrowStates() call below may see an unstyled track (scrollWidth ===
    // clientWidth, both arrows disabled). Recompute whenever the track resizes
    // — including the layout settle once the stylesheet applies and again on
    // viewport resize.
    const resizeObserver = new ResizeObserver(updateArrowStates);
    resizeObserver.observe(track);
    state.resizeObserver = resizeObserver;

    state.cleanup = function () {
      prevBtn.removeEventListener('click', scrollPrev);
      nextBtn.removeEventListener('click', scrollNext);
      track.removeEventListener('scroll', updateArrowStates);
      if (state.resizeObserver) state.resizeObserver.disconnect();
      if (state.mobileRevealObserver) state.mobileRevealObserver.disconnect();
    };

    // On mobile, reveal all cards (including the peeking one) together
    // when the grid scrolls into view, so the stagger animation plays
    // but no card stays hidden due to being partially off-screen.
    function initMobileReveal() {
      if (window.innerWidth >= 750) return;

      const cards = track.querySelectorAll('.oddit-section-blog-grid__card.oddit-reveal');
      if (!cards.length) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            cards.forEach((card) => card.classList.add('is-visible'));
            observer.disconnect();
          }
        });
      }, { threshold: 0.1 });

      observer.observe(track);
      state.mobileRevealObserver = observer;
    }

    initMobileReveal();
    updateArrowStates();
  }

  function destroySection(section) {
    const key = section.id || section;
    const state = sectionState.get(key);
    if (!state) return;
    if (state.cleanup) state.cleanup();
    sectionState.delete(key);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();